<template class="template-page" >
    <div class="container" >

    </div>
</template>

<script>
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_CHECK } from '@/store/actions/auth'
import { mapGetters, mapState } from 'vuex'
    
export default {
    name: "logoutPage",
    data () {
        return {
            form: {
                username: '',
                password: '',

            },
            show: true,
            error: false,
            errorMessage: 'Credentials invalid. Please try again',
            redirect : '',
        }
    },
    beforeCreate: function (){
        
    },
    created: function () {
        
       //window.location.href = '/login'
       this.$router.push('/login')

    },
    methods: {
        
    },
    computed: {
        
    },
}
</script>

<style lang="scss" scoped >
    html, body{
        background: #eaeaea!important;
    }
    
</style>


// WEBPACK FOOTER //
// src/templates/auth/Logout.vue